import {IOrganization} from "./organization.model";
import {IStep} from "./step.model";

export interface IActionType {
  id?: number;
  itemName?: string;
  status?: string;
  step?: IStep;
  step_str?: any;
  description?: string;
  organization?: IOrganization;

}

export class ActionType implements IActionType {
  constructor(public id?: number, public itemName?: string, public status?: string, public step?: IStep, public step_str?: any, public description?: string, public organization?: IOrganization) {
  }
}
